export default __webpack_public_path__ + "static/media/YouTubeUserScreen_Final.c22a81be.jpeg";